<template>
<div class="create px-8 py-4">
    <div>
        <lCrumbs :breadcrumb="breadcrumbItems" />
        <div class="mb-8 text-xl text-black">Edit Instructor</div>
        <div class="mt-12">
            <div class="md:flex w-full">
                <div class="w-full md:w-1/2">
                    <div class="md:mx-12">
                        <div class="item md:flex md:items-center w-full mb-12">
                            <div class="w-full md:w-1/4 mr-4">
                                <label class="text-black font-bold" for="">First Name:
                                </label>
                            </div>
                            <div class="w-full">
                                <linput type="text" name="first_name" v-model="form.first_name" :errorMessage="errors.first_name" :error="errors.first_name" placeholder="e.g Jane" />
                            </div>
                        </div>
                    </div>
                    <div class="md:mx-12">
                        <div class="item md:flex md:items-center w-full mb-12">
                            <div class="w-full md:w-1/4 mr-4">
                                <label class="text-black font-bold" for="">Last Name: </label>
                            </div>
                            <div class="w-full">
                                <linput type="text" name="last_name" v-model="form.last_name" :errorMessage="errors.last_name" :error="errors.last_name" placeholder="e.g Doe" />
                            </div>
                        </div>
                    </div>
                    <div class="md:mx-12">
                        <div class="item md:flex md:items-center w-full mb-12">
                            <div class="w-full md:w-1/4 mr-4">
                                <label class="text-black font-bold" for="">Email: </label>
                            </div>
                            <div class="w-full">
                                <linput type="text" name="email" v-model="form.email" :errorMessage="errors.email" :error="errors.email" placeholder="e.g mail@mail.com" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full md:w-1/2">
                    <div class="md:mx-12">
                        <div class="item md:flex md:items-center w-full mb-12">
                            <div class="w-full md:w-1/4 mr-4">
                                <!-- <label class="text-black font-bold" for=""
                    >instructor Image:
                  </label> -->
                            </div>
                            <div>
                                <vue-dropzone @vdropzone-drag-drop="
                      form.image = $event;
                      uploads = [''];
                    " @vdropzone-file-added="
                      form.image = $event;
                      uploads = [''];
                    " ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                                <small class="text-red-500" v-if="errors.image">The instructor image field is required</small>
                                <div class="mt-4">
                                    <img :src="form.image" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full text-center">
            <lms-button class="mb-12" @click="handleSubmit">Update </lms-button>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapMutations
} from "vuex";
import _get from "lodash.get";
import FormActions from "@/mixins/FormActions";
export default {
    mixins: [FormActions],
    data() {
        return {
            activeTab: 2,
            uploads: [],
            form: {},
            errors: {},
            breadcrumbItems: [{
                    disabled: true,
                    to: "/tenant/instructor",
                    text: "All Instructors",
                },
                {
                    disabled: true,
                    to: "",
                    text: "Edit Instructor",
                },
            ],
        };
    },
    components: {
        linput: () => import("@/components/general/input"),
        steps: () => import("@/components/general/steps"),
        LmsButton: () => import("@/components/general/button"),
        lcontainer: () => import("@/components/general/container"),
        lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
    },
    methods: {
        ...mapActions(["tenantUpdateInstructor", "tenantEditInstructor"]),
        ...mapMutations(["updateLoader"]),
        async handleSubmit() {
            this.errors = [];
            this.updateLoader(true);
            if (this.uploads.length > 0) {
                this.form.image = await this.uploadFile(this.form.image);
            }
            let res = await this.tenantUpdateInstructor(this.form);
            this.updateLoader(false);
            if (res.status == 201 || res.status == 200) {
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Instructor edited successfully",
                });
                this.uploads = [];

                this.$router.push({
                    name: "tenant-instructor-home",
                });
            } else {
                this.errors = res.data.errors[0].source;
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title : "An error occured",
                });
            }
        },
    },
    async mounted() {
        this.updateLoader(true);
        let res = await this.tenantEditInstructor({
            id: this.$route.params.id,
        });
        this.form = _get(res, "data.data.instructor");
        this.updateLoader(false);
    },
};
</script>
